import useLocaleNavigation from 'i18n/useLocaleNavigation';
import React from 'react';
import getTheme from 'utils/getTheme';

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { language } = useLocaleNavigation();
  const customTheme = getTheme(language) as React.CSSProperties;

  return <div style={customTheme}>{children}</div>;
};

export default ThemeProvider;
